export default {"src":"/statics/ecommerce/_next/static/media/toutatis-big-logo.a6b6f2de.svg","height":56,"width":124,"blurWidth":0,"blurHeight":0};